import script from "./GridView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridView.vue?vue&type=script&setup=true&lang=ts"

import "./GridView.vue?vue&type=style&index=0&id=4151fdb8&scoped=true&lang=css"

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4151fdb8"]])

export default __exports__